import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { AuthService } from '../../../../services/auth.service';
import { UserService } from '../../../../services/user.service';
import { Program, UserDetails } from '../../../../interfaces/user.interface';
import { LoggerService } from '../../../../shared/services/logger.service';
import { MenuDropButtonComponent } from "../../../../shared/menu-drop-button/menu-drop-button.component";
import { MenuService } from '../../../../services/menu.service';
import { MainMenuItem } from '../../../../interfaces/menu.interface';
import { RoutingService } from '../../../../shared/services/routing.service';
import { AlertboxComponent } from "../../../../shared/components/alertbox/alertbox.component";
import { ToasterBackupComponent } from "../../../../shared/components/toaster-backup/toaster-backup.component";
import { SideDrawerComponent } from "../../../../shared/components/side-drawer/side-drawer.component";
import { NotificationsComponent } from "../../../../shared/components/notifications/notifications.component";
import { environment } from '../../../../../environments/environment';
import { MenuItem } from 'primeng/api';
import { StorageService } from '../../../../services/storage.service';

@Component({
  selector: 'ppl-header',
  standalone: true,
  imports: [CommonModule,/*  MatIconModule, */ ButtonComponent, MenuDropButtonComponent, AlertboxComponent, ToasterBackupComponent, SideDrawerComponent, NotificationsComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  isVisible = false;
  dropdownOpen = false;
  userDetails: UserDetails | undefined;

  isAlertVisible = false;
  isToasterVisible = false;
  isSideDrawerVisible = false;

  handleClose(): void {
    console.log("Alert was closed");
    this.isAlertVisible = false;
  }

  handleToasterClose(): void {
    console.log("Alert was closed");
    this.isToasterVisible = false;
  }

  handleSideDrawerClose(): void {
    console.log("Alert was closed");
    this.isSideDrawerVisible = false;
  }

  menuItemstoDisplay?: MainMenuItem;
  menuSelected: string | undefined;
  selectedMenuItem?: MenuItem;
  selProgramCode?: string;
  menu?: MainMenuItem;
  selectedProgram = '';
  isInternalApp = true;
  disableMenu: boolean = false;

  constructor(private userService: UserService,
    private authService: AuthService, private router: RoutingService, private logger: LoggerService, private menuService: MenuService,
    private storageService: StorageService) {
    this.isInternalApp = !environment.isExternal;
  }

  ngOnInit() {
    this.authService.userDetailsSubject$.subscribe(
      (userDetails) =>{
        this.userDetails = userDetails?.responsedata
      }

    );

    this.userService.selectedProgramSubject.subscribe((program: Program) => {
      const restrictedMenus = this.userService.getRestrictedMenus();
      this.disableMenu = restrictedMenus.length > 0 ? restrictedMenus.indexOf("disableMenu") != -1 : false;
      this.selectedProgram = program.program_name
      this.selProgramCode = program.program_code;
      this.menuItemstoDisplay = this.menuService.getAvailableMenus(this.selProgramCode, restrictedMenus);
      this.selectedMenuItem = this.menuItemstoDisplay["Basic"][0];

      this.storageService.setFirstMenu(this.selectedMenuItem['menu_id'] as string);
    })
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  // Close dropdown when clicking outside of it
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Check if the clicked element is within the profileClick container or the dropdown menu
    const clickedInside = target.closest('.profileClick') || target.closest('.dropdown-menu');

    if (!clickedInside && this.dropdownOpen) {
      this.dropdownOpen = false;
    }
  }

  manageProfile() {
    console.log('Manage Profile clicked');
  }

  logout(): void {
    this.authService.logout();
  }

  homeRedirection() {
    this.menu = undefined;
    this.selectedProgram = '';
    this.menuItemstoDisplay = undefined;
    this.userService.removeSelectedMenu();
    this.router.navigate(`/`);
  }
}
